module.exports = __webpack_public_path__ + "static/media/archero2_page_area03_img_cn@2x.df17f729.png";